import { css } from '@emotion/react';

import { runtimeConfig } from 'runtimeConfig';

const RIBBONS = {
  'local': { label: 'LOCAL', color: '#b26a00' },
  'go-dev': { label: 'GO DEV', color: '#1565c0' },
  'go-prod': { label: 'GO PROD', color: '#c62828' },
  'wf-prod': { label: 'WF PROD', color: '#c62828' },
};

export default function EnvironmentRibbon() {
  const ribbon = runtimeConfig.backendEnv && RIBBONS[runtimeConfig.backendEnv];
  if (!ribbon) return null;

  return (
    <div
      css={css`
        pointer-events: none;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1500;
        width: 64px;
        height: 64px;
        overflow: hidden;
      `}
    >
      <div
        css={css`
          position: absolute;
          top: 0;
          left: 0;
          width: 90px;
          padding: 1px 0;
          transform: translate(-21px, 17px) rotate(-45deg);
          background-color: ${ribbon.color};
          color: white;
          font-size: 9px;
          font-weight: bold;
          letter-spacing: 1px;
          text-align: center;
        `}
      >
        {ribbon.label}
      </div>
    </div>
  );
}
